import React, {Component} from 'react';
import { Link } from 'react-router-dom';

import '../../scss/player.css'
// Layout
import Header from "../layout/header2";
import Footer from "../layout/footer";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import pic1 from "../../images/about/pic-1.jpg";
import icon1 from "../../images/icon/icon1.png";
import icon2 from "../../images/icon/icon2.png";
import icon3 from "../../images/icon/icon3.png";
import animateWave from "../../images/shap/wave-blue.png";
import animate2 from "../../images/shap/circle-dots.png";
import animateRotate from "../../images/shap/plus-blue.png";

import permisoCofepris from "../../images/2301012002A00103.pdf";
  

 
class ContactUs extends Component{
		
 	render(

		
	){
		return (
			<>
				
				<Header />
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner banner-lg contact-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h2>Permiso COFEPRIS - 2301012002A00103</h2>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Inicio</Link></li>
											<li className="breadcrumb-item active" aria-current="page">COFEPRIS</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={animateWave} alt=""/>
							<img className="pt-img2 animate2" src={animate2} alt=""/>
							<img className="pt-img3 animate-rotate" src={animateRotate} alt=""/>
						</div>
					</div>
					
					<section className="">
						<div className="container">
							<div className="contact-wraper">
								<div className="row">
									<div className="col-lg-12 mb-30 container_cofepris" >
										<div className="contact-info ovpr-dark" style={{backgroundImage: "url("+pic1+")"}}>
											<div className="info-inner container_cofepris">
											<object data={permisoCofepris} type='application/pdf' width="100%" height="100%">
												<p className='text_cofepris'>Tu explorador no soporta visualizar archivos PDF, Puedes verificar el Permiso 
												<a target="_blank" rel="noreferrer"  href="https://digipris.cofepris.gob.mx/getTramite?id=2GuKHloI%2Fgd3bCJTkymjKQHBbQVBcNL5"><i className="fab fa-check-f"></i> AQUI </a>
												o Descargar el Permiso
												<a href={permisoCofepris} download><i className="fab fa-check-f"></i> AQUI </a>
												</p>
										    </object>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					
					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								<div className="col-lg-4 col-md-6 mb-30">
									<div className="feature-container feature-bx4 feature4">
										<div className="icon-md feature-icon">
											<img src={icon1} alt=""/>
										</div>
										<div className="icon-content">
											<h5 className="ttr-title">Emergencias</h5>
											<a target="_blank" rel="noreferrer" href="tel:4491647579">449 164 7579 (24 Hrs - 365 dias)</a>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 mb-30">
									<div className="feature-container feature-bx4 feature3">
										<div className="icon-md feature-icon">
											<img src={icon3} alt=""/>
										</div>
										<div className="icon-content">
											<h5 className="ttr-title">Email</h5>
											<a target="_blank" rel="noreferrer" href="mailto:dr.alvarezdelcastillo@gmail.com">dr.alvarezdelcastillo @ gmail.com</a>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 mb-30">
									<div className="feature-container feature-bx4 feature2">
										<div className="icon-md feature-icon">
											<img src={icon2} alt=""/>
										</div>
										<div className="icon-content">
											<h5 className="ttr-title">Dirección</h5>
											<a target="_blank" rel="noreferrer" href="https://goo.gl/maps/W4hoPAVBjZkY65df8">Republica de Brasil No 712, Colonia Las Américas, C.P. 20230 Aguascalientes, Ags.</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				
				</div>
				
				<Footer />
				
			</>
		);
	}
}

export default ContactUs;
